var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('warehouse-companies',{attrs:{"formTab":_vm.form,"openModal":_vm.openModal}}),_c('modal-warehouse-companies',{attrs:{"formTab":_vm.form,"companyId":this.$route.params.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }